import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { RoutingPath } from "src/app/configs/routing-path";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { RequestService } from "src/app/core/services/request/request.service";
import { environment } from "src/environments/environment";
import { IAfiliado } from "../../core/models/user/user";
import { NotificationService } from "../../core/services/notification/notification.service";
import { TiposIdentidadBuscador } from "src/app/core/enums/documents-type.enum";
import { ModalService } from "src/app/core/services/modal/modal.service";
import { Location } from "@angular/common";
declare var dataLayer;

@Component({
    selector: "app-notify",
    templateUrl: "./notify.component.html",
    styleUrls: ["./notify.component.scss"],
    standalone: false
})
export class NotifyComponent implements OnInit, OnDestroy {
  public jwTokenData: any;
  public afiliate: IAfiliado;
  public counterRequest = 0;
  public counterRequestDefault: boolean;
  public menu: any;
  prePage: string;
  prePageDefault: string;
  subscription: Subscription;
  public dropActive = false;
  public popupSolicitudesId = 'popup-solicitudes';

  @Output() overlayActive: EventEmitter<boolean>;

  constructor(
    public _changeDetector: ChangeDetectorRef,
    public requestService: RequestService,
    private notificationService: NotificationService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private _MODAL: ModalService,
    private location: Location
  ) {
    this.overlayActive = new EventEmitter();
  }

  ngOnInit() {
    let userloggedin = this.localStorageService.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    let notification: [] = this.localStorageService.getItemJSON(environment.LOCAL_STORAGE.BUSINESS_NOTIFICATION_INFORMATION);

    let numberDocumentBusiness = userloggedin.docNumberCompany;

    this.requestService.checkDevueltos(numberDocumentBusiness).subscribe((respuesta) => {
      this.counterRequestDefault = respuesta;
      if (respuesta === true) {
        this.verificarYMostrarPopup();
      }
    })

    if (notification === undefined || notification === null) {
      this.notificationService.getNotify().subscribe((d) => {
        if (d !== undefined) {
          this.counterRequest = d + 1;
        }
      });
    }
    this.counterRequest = notification != null ? notification.length : 0;

    this.prePage = `${RoutingPath.appRouting.components.subsidy.path}/`;
    this.prePage +=
      RoutingPath.appRouting.components.subsidy.pages.notifications.path;
    this.prePageDefault = `${RoutingPath.appRouting.components.individual_retreat.path}/`;
    this.prePageDefault +=
      RoutingPath.appRouting.components.individual_retreat.pages.list_request.path;
    this.menu = document.getElementsByClassName("mat-menu-panel");
  }

  /**
 * Verifica si debe mostrar el popup al usuario
 */
  private verificarYMostrarPopup(): void {
    const esPrimerLogin = this.esPrimerLoginEnSesion();
    const popupCerrado = sessionStorage.getItem('popup_solicitudes_cerrado') === 'true';
    if (esPrimerLogin && this.counterRequestDefault && !popupCerrado) {
      setTimeout(() => {
        this.mostrarPopupSolicitudes();
      }, 1000);
    }
  }

  private esPrimerLoginEnSesion(): boolean {
    const sessionKey = 'primer_login_completado';
    if (!sessionStorage.getItem(sessionKey)) {
      sessionStorage.setItem(sessionKey, 'true');
      return true;
    }
    return false;
  }

  public mostrarPopupSolicitudes(): void {
    sessionStorage.setItem('bloquear_popup_carga_masiva', 'true');
    this._MODAL.openModal(this.popupSolicitudesId);
  }

  public irASolicitudesPendientes(confirmado: boolean): void {

    if (confirmado) {
      this.goToNewsDefault();
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  goToNewsDefault(notify?: boolean) {
    if (notify) {
      dataLayer.push({
        'event': 'ga_event',
        'eventName': 'click',
        'seccion': 'Campana notificación',
        'page_path': this.location.path,
        'label': 'Tienes ajustes pendientes en el listado de tus solicitudes',
        'link_text': 'Pendientes',
      })
    }
    this.router.navigateByUrl(this.prePageDefault);
  }

  goToNews() {
    this.router.navigateByUrl(this.prePage);
    this.hiddeToggle();
  }

  show(event: any) {
    this.dropActive = !this.dropActive;
    this.overlayActive.emit(this.dropActive);
    let expand = this.dropActive ? "true" : "false";
  }

  close() {
    if (this.menu[0] != undefined)
      this.menu[0].parentElement.style.visibility = "collapse";
  }

  hiddeToggle() {
    this.dropActive = !this.dropActive;
  }
  clickButtonNotification(): void {
    this.notificationService.clickButtonNotification(true);
    setTimeout(() => {
      document.querySelectorAll('[role="menu"]').forEach(function (el) {
        el.removeAttribute("role");
      });
    }, 100);
  }
}
